// src/api/blogApi.js
import api from '../api/Restapi';

const blogApi = {
  getAll: async () => {
    const res = await api.get('/blog');
    const blogs = Array.isArray(res.data) ? res.data : res.data.data || [];
    return blogs.map(blog => ({
      ...blog,
      imageUrl: blog.image_url,
    }));
  },

  getBySlug: async (slug) => {
    const res = await api.get(`/blog/slug/${slug}`);
    const blog = res.data?.data || res.data;
    return {
      ...blog,
      imageUrl: blog.image_url,
    };
  },

  create: async (payload) => {
    const res = await api.post('/blog', payload);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await api.put(`/blog/${id}`, payload);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/blog/${id}`);
    return res.data;
  },
};

export default blogApi;
